
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../../../../Helper/Context'
import IllegalConstructionSidebar from './IllegalConstructionSidebar/IllegalConstructionSidebar'
import { IllegalConstructionDashboardComponents } from './IllegalConstructionDashboardComponents/IllegalConstructionDashboardComponents'
export const IllegalConstructionDashboard = () => {

    const { t } = useTranslation()
    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails
    const dispatch = useDispatch()


    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: ''
    })

    useEffect(() => {
        setLanguage({
            ...Language,
            DDL: [],
            ID: 0,
            Label: localStorage.getItem('LanguageChange'),
        })
    }, [])


    const [IsDashPost, setIsDashPost] = useState(false)
    const DataObj = ({
        isCountLoading: '',
        Language: Language.Label
    })


    return (
        <>
            <div>
                <div className="wrapper bg-change">
                    <IllegalConstructionSidebar
                    />
                    <div className="content1 content mt-1 " style={{}}>
                        <IllegalConstructionDashboardComponents
                            DataObj={DataObj} />

                    </div>

                </div>
            </div>


        </>

    )
}